import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FilterIcon from "@mui/icons-material/Tune";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Menu,
  MenuItem,
  Paper,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { CircleLoader } from "react-spinners";
import {
  alcoholAddRequest,
  alcoholEditRequest,
  alcoholResetState,
  alcoholViewAllRequest,
} from "../../../redux/typeOfAlcohol/TypeOfAlcoholAction";
import { getColumnWidth } from "../../../style/datagridMQ";
import {
  ActiveValue,
  InactiveValue,
  StyledContainer,
} from "../../components/style";
import CustomButton from "../../constant/commonButton";
import CustomDataGrid from "../../constant/commondatagrid";
import ReusableFormFields from "../../constant/reusableFormFields";
import CommonSnackbar from "../../notification/Snackbar";
import Pagination from "../../constant/CommonPagenation";
import { filterStyles, styles } from "../../components/LoginStyles";

const TypeOfAlcohol = () => {
  const [rows, setRows] = useState([]);
  const [selection, setSelection] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [brandToDelete, setBrandToDelete] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const [editBrand, setEditBrand] = useState(null);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [emptyList, setEmptyList] = useState([]);
  //search
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState,
    control,
    setValue,
    reset,
    setError,
  } = useForm();
  const { errors } = formState;

  const typeOfAlcoholState = useSelector(
    (state) => state?.TypeAlcohol?.viewAllAlcohols || {}
  );
  const addAlcoholState = useSelector(
    (state) => state?.TypeAlcohol?.addAlcohol || {}
  );
  const editAlcoholState = useSelector(
    (state) => state?.TypeAlcohol?.editAlcohol || {}
  );
  const typeOfAlcoholList = typeOfAlcoholState?.data?.data || [];
  const totalRecords = typeOfAlcoholState?.data?.totalRecords || 0;
  const typeOfAlcoholPageSize = typeOfAlcoholState?.pageSize || 10;

  const columns = (handleDeleteRow) => [
    {
      field: "alcohol_code",
      headerName: "Alcohol Code",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "N/A",
    },
    {
      field: "alcohol_type",
      headerName: "Alcohol Name",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Unknown",
    },
    {
      field: "status",
      headerName: "Status",
      width: getColumnWidth("column"),
      renderCell: (params) => {
        return params?.value === 1 ? (
          <ActiveValue>Active</ActiveValue>
        ) : (
          <InactiveValue>Inactive</InactiveValue>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: getColumnWidth("actions"),
      renderCell: (params) => (
        <Box display="flex" gap="10px" mt={3}>
          <CustomButton
            variant="contained"
            buttonStyle="SubmitButton"
            color="primary"
            startIcon={<EditIcon />}
            onClick={() => {
              reset();
              setEditBrand(params.row);
              setOpenEditDialog(true);
              setValue("alcohol_type", params?.row?.alcohol_type);
              setValue("status", params?.row?.status?.toString());
            }}
          >
            Edit
          </CustomButton>
        </Box>
      ),
    },
  ];

  const inputFields = [
    {
      name: "alcohol_type",
      label: "Alcohol Name",
      rules: {
        required: "Alcohol is required",
      },
    },
  ];

  const inputField = [
    {
      name: "alcohol_type",
      label: "Alcohol Name",
      rules: {
        required: "Alcohol is required",
      },
    },
    {
      name: "status",
      label: "Status",
      type: "select",
      options: [
        { value: "1", label: "Active" },
        { value: "2", label: "Inactive" },
      ],
      defaultValue: typeOfAlcoholList.status,
      rules: { required: "Status is required" },
    },
  ];

  // useEffect(() => {
  //   const fetchData = async () => {
  //     await dispatch(alcoholViewAllRequest(currentPage));
  //   };
  //   fetchData();
  // }, [dispatch, currentPage]);

  // useEffect(() => {
  //   if (typeOfAlcoholState?.success) {
  //     setRows(typeOfAlcoholList);
  //   } else {
  //     setRows(emptyList);
  //   }
  // }, [typeOfAlcoholState, typeOfAlcoholList]);

  const getAlcoholListPayload = (pageNo, pageSize, searchKey = "") => ({
    pageNo,
    pagesize: pageSize,
    pagination_required: true,
    search_key: searchKey.trim(),
  });

  const fetchData = async (page, search) => {
    const payload = getAlcoholListPayload(page, typeOfAlcoholPageSize, search);
    await dispatch(alcoholViewAllRequest(payload));
  };

  useEffect(() => {
    const page = currentPage || 1;
    const search = searchQuery?.trim() || "";

    const debounceTimer = setTimeout(() => {
      fetchData(page, search);
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [currentPage, searchQuery]);

  // useEffect(() => {
  //   setRows(typeOfAlcoholList || emptyList);
  // }, [typeOfAlcoholList]);

    useEffect(() => {
      if (typeOfAlcoholState?.success) {
        setRows(typeOfAlcoholList);
      } else {
        setRows(emptyList);
      }
    }, [typeOfAlcoholState, typeOfAlcoholList]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleDeleteRow = (id) => {
    setBrandToDelete(id);
    setOpenAddDialog(true);
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handelAddBrand = () => {
    reset({
      alcohol_type: "",
    });
    setOpenAddDialog(true);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleFilterCondition = (condition) => {
    const sortedRows = [...rows];
    switch (condition) {
      case "Sort by Alcohol Name Asc":
        sortedRows.sort((a, b) =>
          a?.alcohol_type?.localeCompare(b?.alcohol_type)
        );
        break;
      case "Sort by Alcohol Name Desc":
        sortedRows.sort((a, b) =>
          b?.alcohol_type?.localeCompare(a?.alcohol_type)
        );
        break;
      default:
        console.log(`Unknown filter condition: ${condition}`);
        break;
    }
    setRows(sortedRows);
    handleFilterClose();
  };

  useEffect(() => {
    if (addAlcoholState?.success) {
      setSnackbarMessage("Type Of Alcohol added successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setOpenAddDialog(false);
      reset({
        alcohol_type: "",
      });
      dispatch(alcoholResetState());
      dispatch(
        alcoholViewAllRequest(
          getAlcoholListPayload(currentPage, typeOfAlcoholPageSize, searchQuery)
        )
      );
    } else if (addAlcoholState?.error) {
      const errorFields = addAlcoholState?.errormessage || {};
      if (typeof errorFields === "string") {
        setError("alcohol_type", {
          type: "manual",
          message: errorFields,
        });
      } else if (
        typeof errorFields === "object" &&
        Object.keys(errorFields).length > 0
      ) {
        Object.keys(errorFields).forEach((field) => {
          setError(field, {
            type: "manual",
            message: errorFields[field],
          });
        });
        setOpenAddDialog(false);
      } else {
        setSnackbarMessage("Failed to add type of alcohol. Please try again.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setOpenAddDialog(false);
      }
    }
  }, [addAlcoholState]);

  useEffect(() => {
    if (editAlcoholState?.success) {
      setSnackbarMessage("Type Of Alcohol updated successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setOpenEditDialog(false);
      reset({
        alcohol_type: "",
        status: "",
      });
      dispatch(alcoholResetState());
      dispatch(
        alcoholViewAllRequest(
          getAlcoholListPayload(currentPage, typeOfAlcoholPageSize, searchQuery)
        )
      );
    } else if (editAlcoholState?.error) {
      const errorFields = editAlcoholState?.errormessage || {};
      if (typeof errorFields === "string") {
        setError("alcohol_type", {
          type: "manual",
          message: errorFields,
        });
      } else if (
        typeof errorFields === "object" &&
        Object.keys(errorFields).length > 0
      ) {
        Object.keys(errorFields).forEach((field) => {
          setError(field, {
            type: "manual",
            message: errorFields[field],
          });
        });
        setOpenAddDialog(false);
      } else {
        setSnackbarMessage(
          "Failed to update type of alcohol. Please try again."
        );
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    }
  }, [editAlcoholState]);

  const handleAddCancel = () => {
    reset({
      alcohol_type: "",
    });
    setOpenAddDialog(false);
  };

  const handleEditCancel = () => {
    reset({
      alcohol_type: "",
      status: "",
    });
    setOpenEditDialog(false);
  };

  const handleAddAlcohol = async (data) => {
    const normalizeText = (text) => text?.replace(/\s+/g, " ").trim();
    await dispatch(
      alcoholAddRequest({
        ...data,
        alcohol_type: normalizeText(data.alcohol_type),
      })
    );
    await dispatch(
      alcoholViewAllRequest(
        getAlcoholListPayload(currentPage, typeOfAlcoholPageSize, searchQuery)
      )
    );
  };

  const handleEditAlcohol = async (data) => {
    const normalizeText = (text) => text?.replace(/\s+/g, " ").trim();
    await dispatch(
      alcoholEditRequest({
        ...data,
        alcohol_type: normalizeText(data?.alcohol_type),
        id: editBrand?.id,
      })
    );
    await dispatch(
      alcoholViewAllRequest(
        getAlcoholListPayload(currentPage, typeOfAlcoholPageSize, searchQuery)
      )
    );
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <Grid container spacing={2} pl={6}>
        <Grid item xs={12} sm={6} md={7} lg={8} xl={9}>
          <Box className="headingTable">
            <h1> Alcohol Categories </h1>
            <Typography variant="body1">
              Here is the complete list of Alcohol Categories data
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={5} lg={4} xl={3}>
          <Box style={filterStyles.style}>
            <Button
              variant="contained"
              onClick={handelAddBrand}
              sx={styles.addButtonColor}
            >
              Add New
            </Button>
            <Button
              variant="contained"
              startIcon={<FilterIcon color="blue" />}
              endIcon={<ExpandMoreIcon />}
              onClick={handleFilterClick}
              sx={filterStyles.filterColor}
            >
              Filter
            </Button>
          </Box>
        </Grid>
      </Grid>
      <StyledContainer>
        <Menu
          anchorEl={filterAnchorEl}
          open={Boolean(filterAnchorEl)}
          onClose={handleFilterClose}
        >
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Alcohol Name Asc")}
          >
            Alcohol Name A-Z
          </MenuItem>
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Alcohol Name Desc")}
          >
            Alcohol Name Z-A
          </MenuItem>
        </Menu>
        <Paper>
          {/* search */}
          <Box display="flex" justifyContent="flex-end" mb={2}>
            <input
              type="text"
              placeholder="Search by name or code..."
              value={searchQuery}
              onChange={handleSearchChange}
              style={{
                padding: "8px 12px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "300px",
              }}
            />
          </Box>
          <Box>
            {typeOfAlcoholState?.inProgress && (
              <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                bgcolor="rgba(255, 255, 255, 0.5)"
                zIndex={1000}
              >
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="100%"
                >
                  <CircleLoader
                    loading={typeOfAlcoholState?.inProgress}
                    size={50}
                    color="#0458D3"
                  />
                </Box>
              </Box>
            )}
            <CustomDataGrid
              rows={rows}
              columns={columns(handleDeleteRow)}
              pageSize={typeOfAlcoholPageSize}
              pagination={true}
              rowHeight={70}
              onSelectionModelChange={(newSelection) => {
                setSelection(newSelection);
              }}
              sx={filterStyles.modalHeight(rows)}
            />
          </Box>
        </Paper>

        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalRecords={totalRecords}
          pageSize={typeOfAlcoholPageSize}
        />

        {/* Add Alcohol Dialog */}
        <Dialog
          open={openAddDialog}
          onClose={() => setOpenAddDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={styles.dialogtitleAddOrEdit}>
            Add New Alcohol Type
          </DialogTitle>
          <DialogContent sx={{ height: "180px" }}>
            <form onSubmit={handleSubmit(handleAddAlcohol)}>
              <ReusableFormFields
                inputFields={inputFields}
                control={control}
                errors={errors}
                register={register}
              />
              <DialogActions>
                <CustomButton
                  buttonStyle="SubmitButton1"
                  type="submit"
                  disabled={addAlcoholState?.TypeAlcohol?.inProgress}
                  loading={addAlcoholState?.TypeAlcohol?.inProgress}
                  sx={styles.dialogtitleAddOrEditSubmitButton}
                >
                  Submit
                </CustomButton>
                <CustomButton
                  onClick={handleAddCancel}
                  sx={styles.dialogtitleAddOrEditCancelButton}
                >
                  Cancel
                </CustomButton>
              </DialogActions>
            </form>
          </DialogContent>
        </Dialog>
        {/* Edit Alcohol Dialog */}
        <Dialog
          open={openEditDialog}
          onClose={() => setOpenEditDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ fontSize: "20px", fontWeight: "bold" }}>
            Update Alcohol Type
          </DialogTitle>
          <DialogContent sx={{ height: "260px" }}>
            <form onSubmit={handleSubmit(handleEditAlcohol)}>
              <ReusableFormFields
                inputFields={inputField}
                control={control}
                errors={errors}
                register={register}
              />
              <DialogActions>
                <CustomButton
                  buttonStyle="SubmitButton"
                  type="submit"
                  disabled={editAlcoholState?.TypeAlcohol?.inProgress}
                  loading={editAlcoholState?.TypeAlcohol?.inProgress}
                  sx={styles.dialogtitleAddOrEditSubmitButton}
                >
                  Submit
                </CustomButton>
                <CustomButton
                  onClick={handleEditCancel}
                  sx={styles.dialogtitleAddOrEditCancelButton}
                >
                  Cancel
                </CustomButton>
              </DialogActions>
            </form>
          </DialogContent>
        </Dialog>
        {/* Snackbar */}
        <CommonSnackbar
          open={snackbarOpen}
          message={snackbarMessage}
          severity={snackbarSeverity}
          onClose={handleSnackbarClose}
        />
      </StyledContainer>
    </>
  );
};
export default TypeOfAlcohol;
